import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import { generalAlertError } from '../../common/utils/alerts';
import { listModifications, resetModifications } from '../../features/afterSale/afterSaleActions';
import Pagination from '../../common/components/elements/Pagination';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
import { after_sale_purchase_statues } from '../../common/constants';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackModifications } from '../../common/utils/joyrideCallbacks';
// import { modificationsSteps } from '../../common/utils/joyrideSteps';
import {
  ModificationsPageStyles,
  PageHeader,
  HeaderActions,
  ModificationCard,
  StatusBadge,
  ActionButton,
  FilterCard,
  SearchButton,
  EmptyState,
  LoadingState,
  ModificationsList,
  InfoChip,
  PostSaleButton,
} from './ModificationsPage.styles';

export function ModificationsPage() {
  const navigate = useNavigate();
  const state = useSelector((store) => store.afterSale.modifications_page);

  const {
    loading, modifications, page_number, total_pages, error,
  } = state;

  const [search, setSearch] = useState({
    search: '',
    date_from: '',
    date_to: '',
    vehicle_plate: '',
  });
  // const [steps, setSteps] = useState([]);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('modifications') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('modifications')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('modifications');
  //   setState({ run: true, tourActive: true });
  // };

  // useEffect(() => {
  //   modificationsSteps(modifications, setSteps);
  // }, [modifications]);

  useEffect(() => {
    (async () => {
      listModifications(1, search);
    })();

    return () => {
      resetModifications();
    };
  }, []);

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  const searchHandler = async (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      search: search.search.trim(),
    };

    listModifications(1, trimmedSearch);
  };

  return error === null ? (
    <ModificationsPageStyles>
      {/* <Joyride
        steps={steps}
        continuous
        showBeacon={showBeacon}
        locale={{
          back: 'Indietro',
          close: 'Chiudi',
          last: 'Fine',
          next: 'Prossima',
          open: 'Apri il modale',
          restart: 'Riavvia il tour ',
          skip: 'Salta',
        }}
        styles={{
          options: joyrideOptions,

          buttonNext: {
            backgroundColor: '#00a651',
            outline: 'none',
          },
          buttonBack: {
            color: '#00a651',
            outline: 'none',
          },
          beaconInner: {
            backgroundColor: '#00a651',
          },
          beaconOuter: {
            borderColor: '#00a651',
            backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
          },
          buttonSkip: {
            outline: 'none',
          },
          buttonClose: {
            outline: 'none',
          },
        }}
        run={run}
        callback={(data) => handleCallbackModifications(data, steps, setState)}
        showSkipButton
        showProgress
      /> */}
      <div className="container-fluid">
        <PageHeader>
          <h2>✏️ Modifica Dati</h2>
          <HeaderActions>
            <PostSaleButton onClick={() => navigate('/after-sale/select')}>
              Vai a Post Vendita
            </PostSaleButton>
            {/* {localStorage.getItem('modifications') === 'done' && (
              <PostSaleButton onClick={() => fireNewQuoteTour()}>
                Tutorial
              </PostSaleButton>
            )} */}
          </HeaderActions>
        </PageHeader>

        <div className="row">
          {/* Main Content */}
          <div className="col-lg-7 col-xl-8 col-xxl-9 order-2 order-lg-1">
            {loading ? (
              <LoadingState className="modifications-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento modifiche in corso...</span>
              </LoadingState>
            ) : (
              <>
                <ModificationsList className="modifications-one">
                  {modifications.length > 0 ? (
                    modifications.map((modification) => (
                      <ModificationCard
                        key={modification.id}
                        className="modifications-two"
                      >
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-2">
                          <div className="modification-content">
                            <div className="customer-name">
                              👤
                              {' '}
                              {modification.quotation.insurance_request.customer.gender !== 'G'
                                ? `${modification.quotation.insurance_request.customer.name} ${modification.quotation.insurance_request.customer.surname}`
                                : modification.quotation.insurance_request.customer.business_name}
                            </div>

                            <div className="modification-details">
                              <div className="detail-row">
                                <StatusBadge>
                                  {after_sale_purchase_statues.find((status) => status.id == modification.status)?.name}
                                </StatusBadge>
                              </div>

                              <div className="info-chips-row">
                                {modification.quotation.insurance_request.product && (
                                  <InfoChip $highlight>
                                    📦
                                    {' '}
                                    {modification.quotation.insurance_request.product.name}
                                  </InfoChip>
                                )}

                                {modification.quotation.company && (
                                  <InfoChip>
                                    🏢
                                    {' '}
                                    {modification.quotation.company.name}
                                  </InfoChip>
                                )}

                                {modification.quotation.insurance_request.vehicle && (
                                  <InfoChip $highlight>
                                    🚗
                                    {' '}
                                    {modification.quotation.insurance_request.vehicle.vehicle_plate}
                                  </InfoChip>
                                )}

                                {modification.quotation.insurance_request.moto && (
                                  <InfoChip $highlight>
                                    🏍️
                                    {' '}
                                    {modification.quotation.insurance_request.moto.moto_plate}
                                  </InfoChip>
                                )}
                              </div>

                              <div className="created-date">
                                🕐 Creato il
                                {' '}
                                {new Date(modification.created_at).toLocaleDateString('it-IT', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center">
                            {modification.status === 5 ? (
                              <Link to={`/modifications/${modification.id}`}>
                                <ActionButton>
                                  📋 Vai a modifica
                                </ActionButton>
                              </Link>
                            ) : (
                              <Link to={`/after-sale/purchase/modification/${modification.id}`}>
                                <ActionButton>
                                  📋 Vai a modifica
                                </ActionButton>
                              </Link>
                            )}
                          </div>
                        </div>
                      </ModificationCard>
                    ))
                  ) : (
                    <EmptyState className="modifications-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Nessuna modifica trovata!</h5>
                      <p>Prova a modificare i filtri di ricerca</p>
                    </EmptyState>
                  )}
                </ModificationsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listModifications}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>

          {/* Filters Sidebar */}
          <div className="col-lg-5 col-xl-4 col-xxl-3 order-1 order-lg-2 mb-4 mb-lg-0">
            <FilterCard className="modifications-three">
              <h5>🔍 Filtri di Ricerca</h5>
              <form
                onSubmit={searchHandler}
                className="d-flex flex-column gap-3"
              >
                <div>
                  <label htmlFor="search">Ricerca cliente</label>
                  <input
                    type="text"
                    name="search"
                    id="search"
                    className="form-control"
                    value={search.search}
                    onChange={handleChange}
                    placeholder="Nome, cognome..."
                  />
                </div>

                <div>
                  <label htmlFor="vehicle_plate">Ricerca targa</label>
                  <input
                    type="text"
                    name="vehicle_plate"
                    id="vehicle_plate"
                    className="form-control"
                    value={search.vehicle_plate}
                    onChange={handleChange}
                    placeholder="Targa..."
                  />
                </div>

                <div>
                  <label htmlFor="date_from">Data creazione da</label>
                  <input
                    type="date"
                    name="date_from"
                    id="date_from"
                    onChange={handleChange}
                    value={search.date_from}
                    className="form-control"
                    lang="it-IT"
                  />
                </div>

                <div>
                  <label htmlFor="date_to">Data creazione al</label>
                  <input
                    type="date"
                    name="date_to"
                    id="date_to"
                    className="form-control"
                    onChange={handleChange}
                    value={search.date_to}
                    min={search.date_from}
                    lang="it-IT"
                  />
                </div>

                <SearchButton type="submit">
                  Cerca
                </SearchButton>
              </form>
            </FilterCard>
          </div>
        </div>
      </div>
    </ModificationsPageStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}
